import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa"; // Filled user icon
import styles from "./Navbar.module.css";
import { useLocation } from "react-router-dom";
import { useUser } from "../../context/UserContext"; // adjust path as needed

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900); // Changed to 900px for mobile and tablets
  const { user } = useUser(); // use context instead of local state
  const location = useLocation();

  const getLinkClass = (path) =>
    location.pathname === path ? `${styles["nav-link"]} ${styles.active}` : `${styles["nav-link"]} ${styles.faded}`;

  // Listen for window resize
  useEffect(() => {
    const handleResize = () => {
      const nowMobile = window.innerWidth <= 900; // Changed to 900px for mobile and tablets
      setIsMobile(nowMobile);

      // If moving to desktop, close the mobile/tablet menu
      if (!nowMobile) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    // Run once on mount in case the screen is already wide
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <nav className={styles.navbar}>
      {/* Hamburger Icon */}
      <div
        className={menuOpen ? `${styles.hamburger} ${styles.open}` : styles.hamburger}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Navigation Links */}
      <ul className={menuOpen && isMobile ? `${styles["nav-links"]} ${styles.active}` : styles["nav-links"]}>
        <li>
          <Link
            to="/"
            onClick={() => setMenuOpen(false)}
            className={getLinkClass("/")}
          >
            Home
          </Link>
        </li>
        <li>
          <Link
            to="/residencies"
            onClick={() => setMenuOpen(false)}
            className={getLinkClass("/residencies")}
          >
            Residencies
          </Link>
        </li>

        <li>
          <Link
            to="/dining"
            onClick={() => setMenuOpen(false)}
            className={getLinkClass("/dining")}
          >
            Dining
          </Link>
        </li>

        <li>
          <Link
            to="/gallery"
            onClick={() => setMenuOpen(false)}
            className={getLinkClass("/gallery")}
          >
            Gallery
          </Link>
        </li>

        <li>
          <Link
            to="/about"
            onClick={() => setMenuOpen(false)}
            className={getLinkClass("/about")}
          >
            About
          </Link>
        </li>
        <li>
          <Link
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className={getLinkClass("/contact")}
          >
            Contact Us
          </Link>
        </li>
        
        {/* Mobile Auth Buttons - Only show in mobile menu */}
        {isMobile && !user && (
          <>
            <li className={styles["mobile-auth-item"]}>
              <Link to="/login" onClick={() => setMenuOpen(false)}>
                <button className={styles["mobile-auth-button"]}>LOGIN</button>
              </Link>
            </li>
            <li className={styles["mobile-auth-item"]}>
              <Link to="/signup" onClick={() => setMenuOpen(false)}>
                <button className={`${styles["mobile-auth-button"]} ${styles["mobile-auth-button-signup"]}`}>SIGN UP</button>
              </Link>
            </li>
          </>
        )}
        
        {/* Mobile User Icon - Only show in mobile menu when logged in */}
        {isMobile && user && (
          <li className={styles["mobile-auth-item"]}>
            <Link to="/ProfilePage" onClick={() => setMenuOpen(false)} className={styles["mobile-user-link"]}>
              <FaUserCircle size={24} />
              <span>Profile</span>
            </Link>
          </li>
        )}
      </ul>

      {/* Logo */}
      <div className={styles.logo}>
        <Link to="/">
          <img src="/WhiteLogoBackground.svg" alt="Logo" />
        </Link>
      </div>

      {/* Auth Buttons OR User Icon - Only show in desktop (not mobile/tablet) */}
      {!isMobile && (
        <div className={styles["nav-auth-buttons"]}>
          {user ? (
            <Link to="/ProfilePage" title="Profile" className={styles["nav-user-icon"]}>
              <FaUserCircle size={28} />
            </Link>
          ) : (
            <>
              <Link to="/login">
                <button className={styles["nav-button"]}>LOGIN</button>
              </Link>
              <Link to="/signup">
                <button className={`${styles["nav-button"]} ${styles["nav-button-signup"]}`}>SIGN UP</button>
              </Link>
            </>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
